// Typed wrapper for auth-svc's support-access MINT endpoint (ADR-0094,
// ticket #0485/#0487). The dashboard only ever mints — the EXCHANGE half
// (POST /auth/support-access/exchange) happens in the PWA (#0488), never
// here.
//
// Base is "auth", not "core" — the mint endpoint lives on auth-svc
// (same service that owns platform-admin TOTP verification), confirmed
// against the shipped route at apps/auth-svc/src/routes/support-access.ts.

import type { SupportAccessMintRequest, SupportAccessMintResponse } from "@bitacorapro/api-types";
import { request } from "../client";

export const supportApi = {
  mintGrant: (body: SupportAccessMintRequest): Promise<SupportAccessMintResponse> =>
    request<SupportAccessMintResponse>("POST", "auth", "/auth/support-access", { body }),
};
